import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'google-logo',
  imports: [CommonModule],
  templateUrl: './google-logo.component.html',
  styleUrl: './google-logo.component.css',
  standalone: true
})
export class GoogleLogoComponent {
  @Input() size: number = 18;
  @Input() viewBox: string = '0 0 48 48';
}
